<script setup lang="ts">
const upcomingShows = [
  { id: 1, name: '周末 Live', date: 'Week 3', venue: '秋叶原 Underground', status: 'planned' },
  { id: 2, name: '月末公演', date: 'Week 4', venue: '涩谷 Club', status: 'confirmed' },
]

const history = [
  { id: 101, name: '出道演出', result: 'success', fans: '+1,200', income: '¥85,000' },
  { id: 102, name: '街头 Live', result: 'normal', fans: '+380', income: '¥12,000' },
]
</script>

<template>
  <div class="max-w-4xl mx-auto space-y-6">
    <div class="flex items-center justify-between">
      <h2 class="text-xl font-display font-bold text-text-primary">演出管理</h2>
      <button class="px-4 py-2 bg-primary text-bg-deep text-sm font-medium rounded-md hover:bg-primary-light transition-colors">
        策划新演出
      </button>
    </div>

    <!-- 即将举行的演出 -->
    <div>
      <h3 class="text-text-secondary text-sm font-medium mb-3">即将举行</h3>
      <div class="space-y-3">
        <div
          v-for="show in upcomingShows"
          :key="show.id"
          class="bg-bg-surface rounded-lg p-4 border border-accent-purple border-opacity-10 flex items-center justify-between"
        >
          <div>
            <p class="text-text-primary font-medium">{{ show.name }}</p>
            <p class="text-text-muted text-xs">{{ show.date }} · {{ show.venue }}</p>
          </div>
          <div class="flex items-center gap-2">
            <span
              class="px-2 py-1 rounded text-xs"
              :class="show.status === 'confirmed' ? 'text-accent-cyan bg-accent-cyan bg-opacity-20' : 'text-accent-gold bg-accent-gold bg-opacity-20'"
            >
              {{ show.status === 'confirmed' ? '已确认' : '策划中' }}
            </span>
            <button class="px-3 py-1.5 border border-bg-elevated text-text-muted text-xs rounded hover:border-accent-purple transition-colors">
              详情
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 演出历史 -->
    <div>
      <h3 class="text-text-secondary text-sm font-medium mb-3">演出历史</h3>
      <div class="bg-bg-surface rounded-lg border border-accent-purple border-opacity-10 overflow-hidden">
        <table class="w-full text-sm">
          <thead class="bg-bg-base text-text-muted text-xs">
            <tr>
              <th class="px-4 py-3 text-left">演出名称</th>
              <th class="px-4 py-3 text-left">结果</th>
              <th class="px-4 py-3 text-right">粉丝增长</th>
              <th class="px-4 py-3 text-right">收入</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="show in history"
              :key="show.id"
              class="border-t border-accent-purple border-opacity-10"
            >
              <td class="px-4 py-3 text-text-primary">{{ show.name }}</td>
              <td class="px-4 py-3">
                <span
                  class="px-2 py-0.5 rounded text-xs"
                  :class="show.result === 'success' ? 'text-accent-cyan bg-accent-cyan bg-opacity-20' : 'text-text-muted bg-bg-base'"
                >
                  {{ show.result === 'success' ? '大成功' : '普通' }}
                </span>
              </td>
              <td class="px-4 py-3 text-right text-accent-cyan tabular-nums">{{ show.fans }}</td>
              <td class="px-4 py-3 text-right text-accent-gold tabular-nums">{{ show.income }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 占位提示 -->
    <div class="bg-bg-surface rounded-lg p-8 border border-accent-purple border-opacity-10 text-center">
      <p class="text-text-muted text-sm">🎪 演出系统开发中...</p>
      <p class="text-text-disabled text-xs mt-1">Phase 1 将实现完整的演出策划与结算功能</p>
    </div>
  </div>
</template>
